export default (function (value) {
  return value;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-actions/es/utils/identity.js
// module id = ./node_modules/redux-actions/es/utils/identity.js
// module chunks = 6 9 11